import React from "react";
import Screen from "./screen";
import PrivateTemplate from "../../../templates/privateTemplate";
import Services from "./services";

const Report = () => {
  const { dataReport } = Services();
  return (
    <PrivateTemplate>
      <Screen data={dataReport} />
    </PrivateTemplate>
  );
};

export default Report;
